import axios from 'axios';

import { apiClient } from '@/api/client';
import type { PreparedUpload, UploadedFile } from './types';

export const uploadFile = async (file: File): Promise<UploadedFile> => {
  const { data: prepared } = await apiClient.post<PreparedUpload>('/v1/suggestions/files');

  // presigned URL이므로 인증 인터셉터가 붙은 apiClient가 아닌 전역 axios로 호출
  await axios.put(prepared.upload_url, file, {
    headers: { 'Content-Type': file.type },
  });

  const { data: uploaded } = await apiClient.post<UploadedFile>(
    `/v1/suggestions/files/${prepared.file_id}/complete`
  );

  return uploaded;
};
